<aaa-modal
  aria-label="Choose a Time"
  i18n-aria-label
  [title]="'Choose a Time'"
  i18n-title
  role="dialog"
  [subtitle]="'Services can be requested up to three days ahead and time slots are two hours for the service'"
  i18n-subtitle
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  contentMode="fit"
  [isOpen]="appointmentDialogState$ | async"
  (aaaModalDidDismiss)="dismissModal()"
  (aaaModalDidPresent)="onOpen()"
>

  <div class="ion-padding-top ion-padding-bottom">
    <drr-date-grid
      [days]="appointmentDays"
      [selectedDay]="selectedDate"
      (selectedDayChange)="onSelectedDay($event)"
    ></drr-date-grid>
  </div>

  <drr-appointment-list-slot
    [appointmentSlots]="selectedDate?.slots"
    [selectedSlot]="selectedSlot"
    (onSelected)="onSelectedSlot($event)"
  ></drr-appointment-list-slot>

  <div class="ion-padding-bottom">
    <aaa-text color="faint" size="caption" i18n>
      Times are estimated based on predicted service support. Actual demand may impact your request time. No cancel fee up to an hour before pickup or anytime before your driver is assigned.
    </aaa-text>
  </div>

  <aaa-button class="confirm-button" expand="block" (click)="onConfirm()" i18n>
    Confirm
  </aaa-button>


</aaa-modal>
